module.exports = __webpack_public_path__ + "img/error_orange.6c2203e9.png";